import { render, staticRenderFns } from "./StudentDisplayPanel.vue?vue&type=template&id=22f86475"
import script from "./StudentDisplayPanel.vue?vue&type=script&lang=js"
export * from "./StudentDisplayPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports